import Link from 'next/link';
import { Button } from '@upzi/web-shell/ui/button';
import { cn } from '@upzi/web-shell/cn';

type CompanyActivityLinkProps = {
  className?: string;
  companyHref: string;
};

export function CompanyActivityLink({
  className,
  companyHref,
}: CompanyActivityLinkProps) {
  return (
    <Button
      asChild
      variant="outline"
      size="lg"
      className={cn(
        'font-body border-outline bg-surface-pure text-on-surface hover:bg-primary-variant h-10 rounded-xl px-4 text-sm font-medium shadow-none',
        className
      )}
    >
      <Link href={companyHref} target="_blank" rel="noopener">
        Xem hoạt động của công ty
      </Link>
    </Button>
  );
}
